import React, { useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import LoadSimple from '../../LoadSimple';
import SelectorAdmin from '../../SelectorAdmin';

const ModalCreateExceptionNew = ({ props, closeExeption }) => {
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const dia = String(ahora.getDate()).padStart(2, '0');
    const horas = String(ahora.getHours()).padStart(2, '0');
    const minutos = String(ahora.getMinutes()).padStart(2, '0');
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };

  const [addingException, setAddingException] = useState(false);
  const [agenciaId, setAgenciaId] = useState(props.dataAgencies.data.length !== 0 ? props.dataAgencies.data.data[0].exception_agency_id : 1);
  
  const [ManttoData, setManttoData] = useState({
    exception_agency_id: agenciaId,
    description: "",
    hostid: props.data.hostid,
    created_at: obtenerFechaActualLocal()
  });

  const getNameById = (id) => {
    const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
    return agency ? agency.name : null;
  };

  const getColorById = (id) => {
    const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
    return agency ? agency.color : null;
  };

  const setTagExcept = (agency_id) => {
    const coordinates = [props.data.longitude.replace(",", "."), props.data.latitude.replace(",", ".")];
    props.mapAux.setZoom(12);
    props.mapAux.setCenter(coordinates);
    new mapboxgl.Popup({
      className: (props.mode === "") ? 'custom-popup-except' : 'custom-popup-except-white',
      closeButton: false,
      closeOnClick: false
    })
    .setLngLat(coordinates)
    .setHTML(`
      <div class='cont-except' style='border: 1px solid #ffffff;'>
        <div class='valexcept' style='background: ${getColorById(agency_id)}'><div class='txtexcept'>${getNameById(agency_id)}</div><br><br></div>
      </div>
    `)
    .addTo(props.mapAux);
  };

  const addException = async () => {
    setAddingException(true);
    try {
      const response = await fetch(props.server.url + '/api/v1/cassia/exceptions', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(ManttoData),
      });

      if (response.ok) {
        setAddingException(false);
        props.handleShowPopup(capitalizeFirstLetter(lang[props.languaje]['completado']), capitalizeFirstLetter((lang[props.languaje]['regGenCorr'])), '', true);
        closeExeption();
        setTagExcept(ManttoData.exception_agency_id);
        props.search_problems();
      } else {
        const data = await response.json();
        props.handleShowPopup('ERROR!', capitalizeFirstLetter((lang[props.languaje]['regNoGenCorr'])), data.detail || 'Favor de reportar', false);
        closeExeption();
      }
    } catch (error) {
      setAddingException(false);
    }
  };

  const changeOption = (option) => {
    const val = option.value === "" ? 0 : (parseInt(option.value));
    setManttoData(prev => ({ ...prev, exception_agency_id: val }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setManttoData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div style={{
      background: 'rgba(15, 30, 56, 0.55)',
      backdropFilter: 'blur(2px)',
      position: 'fixed', inset: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 12,
        width: '100%', maxWidth: 440,
        boxShadow: '0 20px 60px rgba(0,0,0,.3), 0 0 0 1px rgba(255,255,255,.05)',
        overflow: 'hidden',
        animation: 'slideUp 0.2s ease'
      }}>
        <style>
          {`
            @keyframes slideUp {
              from { opacity: 0; transform: translateY(12px) }
              to   { opacity: 1; transform: translateY(0) }
            }
          `}
        </style>

        {/* HEADER */}
        <div style={{ background: '#0f2d5e', padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 30, height: 30, borderRadius: 7,
              background: 'rgba(255,255,255,.12)',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#fff' }}>
                Crear Excepción
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,.5)', marginTop: 1 }}>
                Registrar excepción para este dispositivo
              </div>
            </div>
          </div>
          <button style={{
            width: 26, height: 26, borderRadius: 6,
            border: '0.5px solid rgba(255,255,255,.15)',
            background: 'rgba(255,255,255,.08)',
            cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            color: 'rgba(255,255,255,.6)'
          }} onClick={closeExeption}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* BADGE EVENT ID */}
        <div style={{ background: '#f1f5f9', borderBottom: '1px solid #e2e8f0', padding: '8px 18px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>
            Event ID
          </span>
          <span style={{
            fontFamily: 'monospace', fontSize: 12, fontWeight: 500,
            color: '#1a56db', background: '#e8f0fe',
            border: '1px solid #c3dafe', borderRadius: 5,
            padding: '2px 10px'
          }}>
            {props.data.eventid}
          </span>
        </div>

        {/* BODY */}
        <div style={{ padding: '18px 18px 14px' }}>
          
          {/* AGENCIA */}
          <label style={{ fontSize: 10, fontWeight: 600, color: '#334155', textTransform: 'uppercase', letterSpacing: '.07em', display: 'flex', alignItems: 'center', gap: 5, marginBottom: 6 }}>
            Agencia
          </label>
          <div style={{ marginBottom: 14 }}>
            <SelectorAdmin 
              placeholder={'Seleccionar agencia...'} 
              opGeneral={false} txtOpGen={''} opt_de={'0'} origen={'Admin'} 
              data={props.dataAgencies.data.data} 
              loading={props.dataAgencies.loading} 
              titulo='' selectFunction={changeOption} index={0}
            />
          </div>

          {/* NOTAS */}
          <label style={{ fontSize: 10, fontWeight: 600, color: '#334155', textTransform: 'uppercase', letterSpacing: '.07em', display: 'flex', alignItems: 'center', gap: 5, marginBottom: 6 }}>
            Notas
          </label>
          <textarea 
            name="description"
            placeholder="Información adicional..."
            value={ManttoData.description}
            onChange={handleChange}
            style={{ width: '100%', border: '1px solid #e2e8f0', borderRadius: 7, color: '#334155', fontSize: 11, padding: '10px 12px', background: '#fff', outline: 'none', resize: 'none', height: 80, lineHeight: 1.5, transition: 'all .15s', marginBottom: 14 }}
            onFocus={e => { e.target.style.borderColor = '#1a56db'; e.target.style.boxShadow = '0 0 0 3px #e8f0fe'; }}
            onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; }}
          />

          {/* FECHA */}
          <label style={{ fontSize: 10, fontWeight: 600, color: '#334155', textTransform: 'uppercase', letterSpacing: '.07em', display: 'flex', alignItems: 'center', gap: 5, marginBottom: 6 }}>
            Fecha
          </label>
          <input 
            name="created_at"
            type="datetime-local"
            value={ManttoData.created_at}
            onChange={handleChange}
            style={{ width: '100%', border: '1px solid #e2e8f0', borderRadius: 7, color: '#334155', fontSize: 12, padding: '9px 12px', background: '#f1f5f9', outline: 'none', fontFamily: 'monospace', marginBottom: 20 }}
          />

          <div style={{ height: 1, background: '#e2e8f0', margin: '0 -18px 14px' }} />

          <div style={{ display: 'flex', gap: 8 }}>
            <button 
              style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, borderRadius: 7, border: '1px solid #e2e8f0', background: '#fff', color: '#334155', fontSize: 12, fontWeight: 500, padding: '9px 20px', cursor: 'pointer' }} 
              onClick={closeExeption}
            >
              Cancelar
            </button>
            <button 
              disabled={addingException}
              style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, borderRadius: 7, border: 'none', background: '#1a56db', color: '#fff', fontSize: 12, fontWeight: 500, padding: '9px 20px', cursor: addingException ? 'not-allowed' : 'pointer', opacity: addingException ? 0.7 : 1 }}
              onClick={addException}
            >
              {addingException ? <LoadSimple /> : 'Crear'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCreateExceptionNew;
